
import React from "react";
import styled from "styled-components";

export default function AccountingAccountSummary({
  summary,
  formatAmount,
}) {
  const accounts = Array.isArray(summary?.accounts)
    ? summary.accounts
    : [];

  return (
    <>
      <AccountsGrid>
        {accounts.map((account) => (
          <AccountCard key={account.accountCode}>
            <AccountCode>{account.accountCode}</AccountCode>

            <AccountAmounts>
              {Number(account.debit || 0) !== 0 && (
                <span>
                  Débit {formatAmount(account.debit)}
                </span>
              )}

              {Number(account.credit || 0) !== 0 && (
                <span>
                  Crédit {formatAmount(account.credit)}
                </span>
              )}

              {Number(account.debit || 0) === 0 &&
                Number(account.credit || 0) === 0 && (
                  <span>Aucun mouvement</span>
                )}
            </AccountAmounts>

            {account.entries.length > 1 && (
              <EntryCount>
                {account.entries.length} écritures regroupées
              </EntryCount>
            )}
          </AccountCard>
        ))}
      </AccountsGrid>

      <Totals>
        <span>
          Débit total : {formatAmount(summary?.debitTotal)}
        </span>
        <span>
          Crédit total : {formatAmount(summary?.creditTotal)}
        </span>
        <BalanceStatus $balanced={Boolean(summary?.balanced)}>
          {summary?.balanced ? "Équilibrée" : "Non équilibrée"}
        </BalanceStatus>
      </Totals>
    </>
  );
}

const AccountsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(min(100%, 220px), 1fr)
  );
  gap: 0.75rem;
  margin-top: 0.9rem;
`;

const AccountCard = styled.div`
  min-width: 0;
  padding: 0.85rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.055);
  border: 1px solid rgba(255, 255, 255, 0.055);
`;

const AccountCode = styled.strong`
  display: block;
  font-size: 1.05rem;
  font-weight: 950;
`;

const AccountAmounts = styled.div`
  display: grid;
  gap: 0.2rem;
  margin-top: 0.35rem;
  opacity: 0.82;
`;

const EntryCount = styled.small`
  display: block;
  margin-top: 0.45rem;
  opacity: 0.58;
`;

const Totals = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.55rem 1rem;
  margin-top: 0.85rem;
  font-size: 0.82rem;
  opacity: 0.82;
`;

const BalanceStatus = styled.span`
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  background: ${({ $balanced }) =>
    $balanced
      ? "rgba(90, 180, 120, 0.18)"
      : "rgba(240, 150, 70, 0.18)"};
  color: ${({ $balanced }) =>
    $balanced ? "#9ff0b9" : "#ffd29d"};
  font-weight: 900;
`;
